/* ADN Forum 2026, landing evento kiosko */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  /* Marquee continuo, usato dalla barra gialla e dal carosello delle foto.
     Il track contiene il gruppo due volte e scorre fino a -50%, cosi' il loop
     e' senza salto. Il gruppo viene ripetuto finche' non copre almeno la
     larghezza della finestra, altrimenti a meta' animazione si vedrebbe un buco. */
  function initMarquee(root, name, pxPerSec) {
    var box = root.querySelector('.adn-' + name);
    if (!box) return;
    var track = box.querySelector('.adn-' + name + '__track');
    var group = box.querySelector('.adn-' + name + '__group');
    if (!track || !group) return;

    var seed = Array.prototype.slice.call(group.children);
    if (!seed.length) return;

    var clone = null;

    function build() {
      if (clone) {
        track.removeChild(clone);
        clone = null;
      }
      while (group.children.length > seed.length) {
        group.removeChild(group.lastElementChild);
      }

      // ripeto SEMPRE il ciclo intero, mai i singoli elementi: cosi' il gruppo e'
      // un multiplo esatto della sequenza e alla giunzione non si vede un doppione
      var guard = 0;
      while (group.getBoundingClientRect().width < window.innerWidth && guard < 40) {
        seed.forEach(function (el) {
          group.appendChild(el.cloneNode(true));
        });
        guard++;
      }

      var width = group.getBoundingClientRect().width;
      if (!width) return;

      clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      // i doppioni non devono essere raggiungibili da tastiera ne' letti due volte
      clone.querySelectorAll('a, button').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);

      box.style.setProperty('--adn-' + name + '-duration', Math.max(8, width / pxPerSec) + 's');
    }

    build();
    window.addEventListener('resize', debounce(build, 250));

    // le immagini cambiano la larghezza del gruppo quando finiscono di caricare
    if (name === 'gallery') {
      var imgs = group.querySelectorAll('img');
      var pending = imgs.length;
      imgs.forEach(function (img) {
        if (img.complete) {
          pending--;
          return;
        }
        img.addEventListener(
          'load',
          function () {
            pending--;
            if (pending <= 0) build();
          },
          { once: true }
        );
      });
    }
  }

  function initDropzone(root) {
    var drop = root.querySelector('.adn-drop');
    if (!drop) return;
    var input = drop.querySelector('input[type="file"]');
    var label = drop.querySelector('.adn-drop__label');
    if (!input || !label) return;

    label.dataset.base = label.textContent;

    function show() {
      var f = input.files && input.files[0];
      label.textContent = f ? f.name : label.dataset.base;
    }

    input.addEventListener('change', show);

    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) {
        e.preventDefault();
        drop.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
      });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        show();
      }
    });
  }

  function initForm(root) {
    var form = root.querySelector('.adn-form');
    if (!form) return;
    var msg = form.querySelector('.adn-form__msg');
    var submit = form.querySelector('.adn-form__submit');
    var endpoint = form.getAttribute('data-endpoint') || '';

    function say(text, state) {
      if (!msg) return;
      msg.textContent = text;
      msg.setAttribute('data-state', state || 'info');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;

      if (!endpoint) {
        say(form.getAttribute('data-msg-nobackend') || '', 'error');
        return;
      }

      if (submit) submit.disabled = true;
      say(form.getAttribute('data-msg-sending') || '', 'info');

      fetch(endpoint, { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json().catch(function () {
            return {};
          });
        })
        .then(function () {
          form.reset();
          var label = root.querySelector('.adn-drop__label');
          if (label && label.dataset.base) label.textContent = label.dataset.base;
          say(form.getAttribute('data-msg-ok') || '', 'ok');
        })
        .catch(function () {
          say(form.getAttribute('data-msg-ko') || '', 'error');
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('.adn').forEach(function (root) {
      if (root.dataset.adnReady) return;
      root.dataset.adnReady = '1';
      initMarquee(root, 'ticker', 90);
      initMarquee(root, 'gallery', 42);
      initDropzone(root);
      initForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
